import { useState } from "react";
import { Share, PlusSquare, X, Smartphone } from "lucide-react";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export default function HomeScreenBanner() {
  const [hidden, setHidden] = useState(() => isStandalone() || sessionStorage.getItem("cl_hs_banner_hidden") === "1");
  if (hidden) return null;
  const close = () => {
    sessionStorage.setItem("cl_hs_banner_hidden", "1");
    setHidden(true);
  };
  return (
    <div className="md:hidden brutal-border border-[#FFD600]/50 bg-[#141414] p-4 mx-4 my-4 relative" data-testid="home-screen-banner">
      <button onClick={close} aria-label="Dismiss" data-testid="home-screen-banner-dismiss" className="absolute top-1 right-1 w-10 h-10 flex items-center justify-center text-muted-foreground hover:text-white">
        <X size={18} />
      </button>
      <div className="flex items-center gap-2 font-heading font-bold pr-8">
        <Smartphone size={18} className="text-[#FFD600] shrink-0" /> Add CarrierLaunch to your home screen for quick access
      </div>
      <div className="mt-3 grid gap-3 text-sm">
        <div data-testid="home-screen-banner-iphone">
          <div className="font-mono-label text-[10px] text-[#FFD600] mb-1">IPHONE (SAFARI)</div>
          <ol className="list-decimal pl-5 text-muted-foreground space-y-0.5">
            <li>Tap <Share size={13} className="inline -mt-0.5 text-[#0A84FF]" /> <b className="text-white">Share</b> at the bottom of the screen</li>
            <li>Tap <PlusSquare size={13} className="inline -mt-0.5" /> <b className="text-white">Add to Home Screen</b>, then <b className="text-white">Add</b></li>
          </ol>
        </div>
        <div data-testid="home-screen-banner-android">
          <div className="font-mono-label text-[10px] text-[#FFD600] mb-1">ANDROID (CHROME)</div>
          <ol className="list-decimal pl-5 text-muted-foreground space-y-0.5">
            <li>Tap the browser menu <b className="text-white">⋮</b> at the top right</li>
            <li>Tap <b className="text-white">Add to Home screen</b> (or <b className="text-white">Install app</b>)</li>
          </ol>
        </div>
      </div>
    </div>
  );
}
